/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IStackProps, Stack } from '@fluentui/react/lib/Stack';
import { ITextProps, ITextStyles } from '@fluentui/react/lib/Text';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import * as React from 'react';
import { TruncatedText } from 'src/core/components/TruncatedText';
import { getScopedTheme, getStylistV2 } from 'src/core/themes/luisStylist';
import { advancedOptionsPaneHeaderHeight } from 'src/luis/verticals/labelingSidePane/constants';

const { styleComponent } = getStylistV2('AdvancedOptionsPane');
const scopedTheme = getScopedTheme('AdvancedOptionsPane');

const titleStyles = classNamesFunction<ITextProps, ITextStyles>()({
    root: { fontSize: 12, color: scopedTheme.titleTextColor }
});

const TitleRoot = styleComponent<IStackProps>(Stack)('TitleRoot', {
    height: advancedOptionsPaneHeaderHeight
});

export const renderAdvancedOptionsTitle = (title: string) => (
    <TitleRoot verticalAlign="center">
        <TruncatedText title={title} maxWidth="100%" styles={titleStyles} fontWeight={600}>
            {title}
        </TruncatedText>
    </TitleRoot>
);
